import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import adminApi, { ADMIN_TOKEN_KEY } from "../../connection/adminApi";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      const { data } = await adminApi.post("api/admin/login", form);
      localStorage.setItem(ADMIN_TOKEN_KEY, data.accessToken);
      navigate("/admin", { replace: true });
    } catch (requestError) {
      setError(
        requestError?.response?.data?.message || "Wrong username or password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box dir="ltr" minH="100vh" display="flex" alignItems="center">
      <Container maxW="sm">
        <Box bg="white" p={8} borderRadius="lg" boxShadow="md">
          <Heading size="md" mb={1}>
            StorkPlus operations
          </Heading>
          <Text fontSize="sm" color="gray.500" mb={6}>
            Platform administrators only.
          </Text>

          {error ? (
            <Alert status="error" mb={4} borderRadius="md" fontSize="sm">
              <AlertIcon />
              {error}
            </Alert>
          ) : null}

          <form onSubmit={submit}>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel fontSize="sm">Username</FormLabel>
                <Input
                  autoFocus
                  autoComplete="username"
                  value={form.username}
                  onChange={(event) =>
                    setForm({ ...form, username: event.target.value })
                  }
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel fontSize="sm">Password</FormLabel>
                <Input
                  type="password"
                  autoComplete="current-password"
                  value={form.password}
                  onChange={(event) =>
                    setForm({ ...form, password: event.target.value })
                  }
                />
              </FormControl>

              <Button type="submit" isLoading={loading} width="100%">
                Sign in
              </Button>
            </Stack>
          </form>
        </Box>
      </Container>
    </Box>
  );
};

export default AdminLogin;
